export const cardStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  border: '1px solid #e0e0e0',
  borderRadius: 12,
  padding: 32,
  width: 260,
  margin: 16,
  boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
  background: '#fff',
};

export const cardsContainerStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'flex-start',
  marginTop: 16,
};

export const configureButtonStyle = {
  padding: '8px 24px',
  fontSize: 16,
  borderRadius: 6,
  border: '1px solid var(--primary-color, #1976d2)',
  background: '#fff',
  color: 'var(--primary-color, #1976d2)',
  cursor: 'pointer',
};
